/*global jQuery:false */
jQuery(document).ready(function () {
    'use strict';

    jQuery('.closeSignIn').on("click", function (e) {
        $.fancybox.close();
        e.preventDefault();
    });
});

